import React, {Component} from "react";
import RolesSection from "./RolesSection";
import MembersSection from "./MembersSection";
import ContentSection from "./ContentSection";

class TabContent extends Component {

    state = {
        maxHeight: 0,
    }

    ref = React.createRef();

    componentDidMount() {
        // var $this = ReactDOM.findDOMNode(this);
        // set el height and width etc.
        this.setState({
            maxHeight: this.ref.current.clientHeight
        });
    }

    render() {
        return (
            <section className={["messages-board-body", this.props.className ?? "" ].join(' ')} ref={this.ref}>
                <RolesSection
                    name={this.props.name ?? ''}
                    defaultRoleList={this.props.defaultRoleList}
                    roleList={this.props.roleList ?? []}
                    roleClick={this.props.roleClick ?? null}
                />
                <MembersSection
                    name={this.props.name ?? ''}
                    memberHeaderExtraContent={this.props.memberHeaderExtraContent ?? null}
                    memberSearchPlaceholder={this.props.memberSearchPlaceholder ?? ''}
                    memberButtonText={this.props.memberButtonText ?? false}
                    memberButtonClick={this.props.memberButtonClick}
                    memberList={this.props.memberList ?? []}
                    memberClick={this.props.memberClick ?? null}
                />
                <ContentSection>
                    {this.props.children}
                </ContentSection>
            </section>
        )
    }
};

export default TabContent;